// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"styles_loadingWrapper__TwH6x","spinner":"styles_spinner__D0yjA"};